import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  signal,
} from '@angular/core';
import { ToastData } from './toast.types';

@Component({
  selector: 'lepi-toast',
  standalone: true,
  templateUrl: './toast.html',
  styleUrls: ['./toast.css'],
  imports: [CommonModule],
})
export class Toast implements OnInit, OnDestroy {
  @Input() toastData!: ToastData;
  @Output() removed = new EventEmitter<string>();

  duplicatesCount = 0;

  private timeoutId?: ReturnType<typeof setTimeout>;
  destroy = signal(false);

  get title() {
    return this.toastData?.title;
  }

  get message() {
    return this.toastData?.message;
  }

  get options() {
    return {
      closeButton: this.toastData?.closeButton ?? true,
      progressBar: this.toastData?.progressBar ?? true,
      enableHtml: this.toastData?.enableHtml ?? false,
      titleClass: this.toastData?.titleClass ?? 'toast-title',
      messageClass: this.toastData?.messageClass ?? 'toast-message',
    };
  }

  ngOnInit() {
    const timeOut = Number(this.toastData?.timeOut ?? 0);
    if (timeOut > 0) {
      this.timeoutId = setTimeout(() => {
        this.remove();
      }, timeOut);
    }
  }

  ngOnDestroy() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }

  remove() {
    this.destroy.set(true);

    // stop timer before emitting
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
      this.timeoutId = undefined;
    }

    // ensure id exists before emitting
    if (this.toastData?.id) {
      this.removed.emit(this.toastData.id);
    }
  }
}
